export const handleReset = () => {
  return initialState
}

export const handleSetText = (state, action) => {
  const { text } = action
  return { ...state, text }
}

export const handleUpdateFile = (state, action) => {
  const { id, file, downloaded } = action

  // Update files object
  const files = {
    ...state.files,
    [id]: {
      ...(state.files[id] ?? {}),
      file: file.file,
      type: file.type,
      downloaded
    }
  }

  // Check if all files have been downloaded
  const downloadDone = Object.values(files).reduce(
    (prev, curr) => prev && curr.downloaded,
    true
  )

  // Update copy state if all files are now downloaded
  let copyReady = state.copyReady
  if (state.downloadNeeded && downloadDone) {
    copyReady = true
  }

  return {
    ...state,
    files,
    downloadDone,
    copyReady
  }
}

export const handleStartCopy = state => {
  // Ready to copy since all files have been downloaded
  if (state.downloadDone) {
    return {
      ...state,
      downloadNeeded: false,
      copyReady: true
    }
  }

  const downloadNeeded = Object.keys(state.files).length > 0

  // No files to download so copy can continue
  if (!downloadNeeded) {
    return {
      ...state,
      downloadNeeded,
      copyReady: true
    }
  }

  return {
    ...state,
    downloadNeeded,
    copyReady: false
  }
}

export const handleFinishCopy = (state, action) => {
  return { ...state, copyReady: false }
}

export const initialState = {
  files: {},
  downloadNeeded: false, // Signals downloads to start after copy is clicked
  downloadDone: false, // All files are downloaded
  copyReady: false, // Copy was clicked and can now proceed
  text: ''
}

export const Actions = {
  RESET: 'RESET',
  SET_TEXT: 'SET_TEXT',
  UPDATE_FILE: 'UPDATE_FILE',
  START_COPY: 'START_COPY',
  FINISH_COPY: 'FINISH_COPY'
}

const Handlers = {
  [Actions.RESET]: handleReset,
  [Actions.SET_TEXT]: handleSetText,
  [Actions.UPDATE_FILE]: handleUpdateFile,
  [Actions.START_COPY]: handleStartCopy,
  [Actions.FINISH_COPY]: handleFinishCopy
}

export const CopyableStateReducer = (state, action) => {
  const { type } = action

  if (type in Handlers) {
    return Handlers[type](state, action)
  }

  throw new Error(`Unknown CopyableState reducer type: ${type}`)
}
